import React from 'react'
// CSS
import '../assets/css/testimonial-card.css'

export default function TestimonialCard(props) {
  return (
    <div className='testimonial_card'>
      <div className='header'>
        <div className='image'>
          <img src={props.image} alt='Testimonial' />
        </div>
        <div className='details'>
          <div className='name'>{props.name}</div>
          <div className='designation'>{props.designation}</div>
        </div>
      </div>
      <div className='content'>
        <p>{props.quote}</p>
        
        <div className='icon'>
          <img src={require('../assets/icons/quote.png')} alt='Quote' />
        </div>
      </div>
    </div>
  )
}
